import React from 'react';

const LoadingIcon = () => (
  <i className="loading-icon fa fa-spin fa-spinner"></i>
);

export default LoadingIcon;
